import isDateOverADay from "src/utils/isDateOverADay";

type ObservationOutcome =
	| "Not Completed (Expired)"
	| "Not Completed (In Progress)"
	| "Compliant"
	| "Not Compliant"
	| "Pass"
	| "Fail"
	| "Completed";

const isObservationCompleted = (
	observation: Partial<PreviousObservationForm>,
	observationType: IObservationType
) => {
	const {
		updated_at: updatedAt,
		score_threshold_passed: scoreThresholdPassed,
		complete,
		compliant
	} = observation;

	let outcome: ObservationOutcome = "Not Completed (In Progress)";
	let isFinished = false;

	if (updatedAt && isDateOverADay(updatedAt) && !complete) {
		outcome = "Not Completed (Expired)";
		isFinished = false;
	}

	if (observationType === "INDIVIDUAL" && complete) {
		compliant ? (outcome = "Compliant") : (outcome = "Not Compliant");
		isFinished = true;
	}

	if (observationType === "STORE_SCORED_ASSESSMENT" && complete) {
		scoreThresholdPassed ? (outcome = "Pass") : (outcome = "Fail");
		isFinished = true;
	}

	if (observationType === "STORE_SELF_ASSESSMENT" && complete) {
		outcome = "Completed";
		isFinished = true;
	}

	if (observationType === "GREAT_CONVERSATION" && complete) {
		outcome = "Completed";
		isFinished = true;
	}

	return { outcome, isFinished };
};

export default isObservationCompleted;
